import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CaseCard({ item, index = 0 }) {
  const metric = item.metrics && item.metrics[0];
  return (
    <Link
      to={`/case-studies/${item.slug}`}
      data-testid={`case-card-${item.slug}`}
      className="group block border border-ash bg-paper transition-colors duration-300 hover:border-obsidian"
    >
      <div className="overflow-hidden">
        {item.cover_image && (
          <img
            src={item.cover_image}
            alt={item.title}
            loading="lazy"
            className="aspect-[4/3] w-full object-cover grayscale transition-transform duration-700 ease-out group-hover:scale-105"
          />
        )}
      </div>
      <div className="flex items-start justify-between gap-4 p-6 md:p-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-progress">
            {item.industry} · {item.company_size}
          </p>
          <h3 className="mt-3 font-serif text-2xl font-medium leading-tight tracking-tight md:text-[1.7rem]">
            {item.title}
          </h3>
          {metric && (
            <p className="mt-4 text-sm text-slategray">
              <span className="font-serif text-xl font-semibold text-obsidian">{metric.value}</span>
              &nbsp;&nbsp;{metric.label}
            </p>
          )}
        </div>
        <span className="mt-1 inline-flex h-9 w-9 shrink-0 items-center justify-center border border-obsidian/15 transition-all duration-300 group-hover:border-progress group-hover:bg-progress group-hover:text-white">
          <ArrowUpRight size={15} />
        </span>
      </div>
      <span className="sr-only">{`Case study ${index + 1}`}</span>
    </Link>
  );
}
